<template>
  <authorization permissionKey="attendance_prescription" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Receituários
        </v-col>

        <authorization
          permissionKey="attendance_prescription"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="auto" v-if="authorization">
            <v-btn
              color="light-blue"
              to="receituario/novo"
              :dark="!attendanceEsigned"
              :disabled="attendanceEsigned"
            >
              Adicionar
            </v-btn>
          </v-col>
        </authorization>
      </v-row>

      <v-row>
        <v-col>
          <PrescriptionList
            :attendance="attendance"
            :allowEdit="!attendanceEsigned"
            :allowDelete="!attendanceEsigned"
          />
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import PrescriptionList from "@/components/prescription/list/index.vue";

  export default {
    name: "Prescriptions",
    components: {
      PrescriptionList,
    },
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
  };
</script>

<style lang="scss" scoped></style>
